import { useState } from "react";

import { useLazyApi } from "@bokio/mobile-web-shared/hooks/useApi/useApi";
import * as proxy from "@bokio/mobile-web-shared/services/api/proxy";
import { getRoute } from "@bokio/shared/route";

import { ReceiptPageView } from "../ReceiptPageView/ReceiptPageView";

interface ReceiptMainPageProps {
	companyId: string;
	id: string;
	allowRotate?: boolean;
	isPdf: boolean;
	version?: number;
	onImageRef?: (imgRef: HTMLImageElement | null) => void;
	onDelete?: () => void;
	overlay?: boolean;
}

export const ReceiptMainPage = ({
	companyId,
	id,
	allowRotate,
	isPdf,
	onDelete,
	overlay,
	version,
	onImageRef,
}: ReceiptMainPageProps) => {
	const [versionState, setVersion] = useState(version);

	const [rotateReceipt, rotateReceiptRequest] = useLazyApi(proxy.Accounting.ReceiptController.Rotate.Post, {
		onSuccess: version => {
			setVersion(version);
		},
	});

	const rotate = () => {
		if (allowRotate && !isPdf) {
			rotateReceipt(companyId, id);
		}
	};

	const src = getRoute("receiptImage", { company: companyId, receiptId: id }, { v: versionState });
	const downloadUrl = getRoute("downloadReceipt", { company: companyId, receiptId: id });
	return (
		<ReceiptPageView
			isPdf={isPdf}
			downloadUrl={downloadUrl}
			imageUrl={src}
			onRotate={rotate}
			isRotating={rotateReceiptRequest.isLoading}
			onImageRef={onImageRef}
			onDelete={onDelete}
			overlay={overlay}
		/>
	);
};
